import { clean } from '@/utils/object';
import moment from 'moment';

/**
 @description: table to mixins
 @param {Promise} axios_get 
 @returns {Object} mixin
**/

export const mixin_list = (axios_get, config = {}) => {
  return {
    data() {
      return {
        list_data: {
          list: [],
          total: 0,
        },
        page: 1,
        pageSize: 20,
        selete: [],
        ordering: '',
        ...config,
      };
    },
    methods: {
      initRules() {
        const formInfo = this.formInfo;
        formInfo.rules = this.$initRules(formInfo.fieldList);
      },
      outExe() {
        this.$confirm(
          '시간이 조금 걸릴 수 있습니다.엑셀 출력하시겠습니까?',
          '알림',
          {
            confirmButtonText: '출력',
            cancelButtonText: '취소',
            type: 'warning',
          }
        )
          .then(async () => {
            // this.excelData = await this.getAllList();//to excel (all data)
            this.export2Excel();
          })
          .catch(() => {});
      },
      outExeAll(type, api) {
        this.$confirm(
          '시간이 조금 걸릴 수 있습니다.엑셀 출력하시겠습니까?',
          '알림',
          {
            confirmButtonText: '출력',
            cancelButtonText: '취소',
            type: 'warning',
          }
        )
          .then(async () => {
            this.excelData = await this.getAllList(type, api ? api : ''); //to excel (all data)
            let arr = [];
            if (type === 'activity_userList') {
              this.excelData.forEach((item, index) => {
                var o = {};
                o['ID'] = item.id;
                o['undefined'] = '';
                o['등록시간'] = item.create_time;
                o['상태'] =
                  item.status === 0
                    ? '승인대기'
                    : item.status === 1
                    ? '승인'
                    : item.status === 2
                    ? '취소'
                    : item.status === 3
                    ? '환불대기'
                    : item.status === 4
                    ? '환불완료'
                    : item.status === 5
                    ? '결제예정'
                    : '';
                o['신청사유'] = item.apply_reason;
                o['아이디'] = item.username;
                o['이름'] = item.real_name;
                o['이벤트 제목'] = item.activity_title;
                o['이벤트 카테고리'] =
                  item.activity_type === 1 ? '스페셜 이벤트' : '클럽창비(대화)';
                o['주소'] = item.user_address + ' ' + item.address_detail;
                o['우편번호'] = item.user_address_code;
                o['취소 사유'] = item.refuse_reason;
                o['휴대폰 번호'] = item.user_phone;
                o['결제금액'] = item.order_pay_amount;
                o['쿠폰 사용'] = item.coupon_title;
                o['수량'] = item.order_quantity || 1;
                arr.push(o);
              });
            } else if (type === 'read_userList') {
              this.excelData.forEach((item, index) => {
                // 단행본 옵션 분리 및 매핑
                const clubChangbiLists = { 1: '', 2: '', 3: '', 4: '', 5: '' }; // 초기화
                if (item.club_changbi) {
                  const lines = item.club_changbi.split('\n'); // \r\n으로 줄바꿈 분리
                  lines.forEach((line) => {
                    const match = line.match(/\(선택도서 (\d+), [^)]+\) .+/); // 선택도서 번호와 내용 추출
                    if (match) {
                      const [, bookNumber] = match; // 선택도서 번호 추출
                      const bookIndex = parseInt(bookNumber, 10); // 번호를 숫자로 변환
                      if (bookIndex >= 1 && bookIndex <= 5) {
                        clubChangbiLists[bookIndex] = line; // 선택도서X에 해당 내용 저장
                      }
                    }
                  });
                } else {
                  if (item.club_changbi_list_1[0])
                    clubChangbiLists[1] = `(${item.club_changbi_list_1[0].author}) ${item.club_changbi_list_1[0].title}`;
                  if (item.club_changbi_list_2[0])
                    clubChangbiLists[2] = `(${item.club_changbi_list_2[0].author}) ${item.club_changbi_list_2[0].title}`;
                  if (item.club_changbi_list_3[0])
                    clubChangbiLists[3] = `(${item.club_changbi_list_3[0].author}) ${item.club_changbi_list_3[0].title}`;
                  if (item.club_changbi_list_4[0])
                    clubChangbiLists[4] = `(${item.club_changbi_list_4[0].author}) ${item.club_changbi_list_4[0].title}`;
                  if (item.club_changbi_list_5[0])
                    clubChangbiLists[5] = `(${item.club_changbi_list_5[0].author}) ${item.club_changbi_list_5[0].title}`;
                }

                var o = {};
                o['ID'] = item.id;
                o['undefined'] = '';
                o['등록시간'] = item.create_time;
                o['아이디'] = item.username;
                o['이름'] = item.real_name;
                o['생년월일'] = item.age;
                o['성별'] =
                  item.gender === '0'
                    ? '남자'
                    : item.gender === '1'
                    ? '여자'
                    : '기타';
                o['휴대폰번호'] = item.phone_num;
                o['주소'] = item.user_address + ' ' + item.address_detail;
                o['우편번호'] = item.user_address_code;
                o['배송 요청사항'] = item.delivery_request;
                o['모임 제목'] = item.club_title;
                o['실제 결제 금액'] = item.order_pay_amount;
                o['쿠폰 사용'] = item.coupon_title;
                o['수량'] = item.order_quantity || 1;
                // o['단행본 옵션'] = item.club_changbi;
                // 선택도서 값을 매핑
                o['선택도서 1'] = clubChangbiLists[1];
                o['선택도서 2'] = clubChangbiLists[2];
                o['선택도서 3'] = clubChangbiLists[3];
                o['선택도서 4'] = clubChangbiLists[4];
                o['선택도서 5'] = clubChangbiLists[5];
                o['취소 사유'] = item.refuse_reason;
                o['주소'] = item.user_address + ' ' + item.address_detail;
                o['상태'] =
                  item.status === 0
                    ? '승인대기'
                    : item.status === 1
                    ? '승인'
                    : item.status === 2
                    ? '취소'
                    : item.status === 3
                    ? '환불대기'
                    : item.status === 4
                    ? '환불완료'
                    : item.status === 5
                    ? '결제예정'
                    : '';
                o['수료증 발급'] = item.allow_print ? 'yes' : 'no';
                // o['조장 아이디'] = item.group_leader;
                arr.push(o);
              });
            } else if (type === 'memberList') {
              this.excelData.forEach((item, index) => {
                var o = {};
                o['ID'] = item.id;
                o['undefined'] = '';
                o['등록시간'] = item.create_time;
                o['아이디'] = item.username;
                o['이름'] = item.real_name;
                o['성별'] =
                  item.gender === 0
                    ? '남자'
                    : item.gender === 1
                    ? '여자'
                    : item.gender === 2
                    ? '기타'
                    : '';
                o['생년월일'] = item.birth;
                o['휴대폰 번호'] = item.phone;
                o['주소'] = item.address + ' ' + item.address_detail;
                o['배송 요청사항'] = item.delivery_request;
                let projectStr = '';
                let projectArr = item.project.split(',');
                projectArr.forEach((item, index) => {
                  switch (item) {
                    case '0':
                      projectStr += this.$t('memberManagement').project0;
                      break;
                    case '1':
                      projectStr += this.$t('memberManagement').project1;
                      break;
                    case '2':
                      projectStr += this.$t('memberManagement').project2;
                      break;
                    case '3':
                      projectStr += this.$t('memberManagement').project3;
                      break;
                  }
                  if (index !== projectArr.length - 1) {
                    projectStr += '/';
                  }
                });
                o['모임 이력'] = projectStr;
                let str = '';
                item.favorite_category.forEach((items, index) => {
                  switch (items) {
                    case 0:
                      str += '문학';
                      break;
                    case 1:
                      str += '인문교양';
                      break;
                    case 2:
                      str += '역사';
                      break;
                    case 3:
                      str += '과학';
                      break;
                    case 4:
                      str += '어린이';
                      break;
                    case 5:
                      str += '청소년';
                      break;
                    case 6:
                      str += '그림책';
                      break;
                    case 7:
                      str += '영어덜트';
                      break;
                    case 8:
                      str += '만화';
                      break;
                    case 9:
                      str += '기타';
                      break;
                  }
                  if (index !== item.favorite_category.length - 1) {
                    str += '/';
                  }
                });
                o['선호 독서 분야'] = str;
                o['교육 업계 종사'] =
                  item.is_library === 0
                    ? '아니오'
                    : item.is_library === 1
                    ? '예'
                    : '';
                o['제3자 동의'] =
                  item.is_policy === 0
                    ? '아니오'
                    : item.is_policy === 1
                    ? '예'
                    : '';
                o['이메일 수신동의'] =
                  item.is_email === 0
                    ? '아니오'
                    : item.is_email === 1
                    ? '예'
                    : '';
                o['SMS 수신동의'] =
                  item.is_sms === 0 ? '아니오' : item.is_sms === 1 ? '예' : '';
                o['계정상태'] =
                  item.disable === 1
                    ? '탈퇴'
                    : item.active === 0
                    ? '계정정지'
                    : item.active === 1
                    ? '사용중'
                    : '휴면';
                arr.push(o);
              });
            } else if (type === 'readTask') {
              this.excelData.forEach((item, index) => {
                var o = {};
                o['ID'] = item.id;
                o['아이디'] = item.username;
                o['이름'] = item.real_name;
                o['미션 제목'] = item.task_title;
                o['미션 제출 제목'] = item.title;
                o['미션 제출 내용'] =
                  this.getSumText(item.content) +
                  this.getSumImgSrc(item.content);
                o['첨부파일'] = item.attach;
                arr.push(o);
              });
            } else if (type === 'readAttendance') {
              this.excelData.forEach((item, index) => {
                var o = {};
                o['ID'] = item.id;
                o['아이디'] = item.username;
                o['이름'] = item.real_name;
                o['미션 제목'] = item.task_title;
                o['미션 제출 제목'] = item.title;
                o['미션 제출 내용'] =
                  this.getSumText(item.content) +
                  this.getSumImgSrc(item.content);
                o['첨부파일'] = item.attach;
                arr.push(o);
              });
            }
            this.export2Excel(arr, type);
          })
          .catch(() => {});
      },

      getSumText(str) {
        return str.replace(/<[^<>]+>/g, '').replace(/&nbsp;/gi, '');
      },
      getSumImgSrc(richtext) {
        let imgList = [];
        richtext.replace(
          /<img [^>]*src=['"]([^'"]+)[^>]*>/g,
          (match, capture) => {
            imgList.push(capture);
          }
        );
        return imgList;
      },
      export2Excel(e, type) {
        var that = this;
        require.ensure([], () => {
          var key = [];
          that.columns.forEach((item) => {
            if (item.label !== '操作' && item.label !== '관리') {
              key.push(item.label);
            }
          });
          // real name
          var head = [];
          let ignore; //record ignore columns
          let multiple;
          document
            .getElementsByTagName('thead')[0]
            .children[0].children.forEach((item, index) => {
              if (
                item.innerText !== '操作' &&
                item.innerText !== '관리' &&
                item.innerText !== ''
              ) {
                head.push(item.innerText);
              } else if (
                item.innerText === '操作' ||
                item.innerText === '관리'
              ) {
                ignore = index;
              } else if (item.innerText === '' && index === 0) {
                multiple = true;
              }
            });
          if (type === 'readTask') {
            //*************** */
            key = Object.keys(e[0]);
            head = Object.keys(e[0]);
          }
          // key.pop()
          // head.pop()
          let arr1 = [];
          document.getElementsByTagName('tbody')[0].children.forEach((item) => {
            var o = {};
            item.children.forEach((k, index) => {
              if (index !== ignore) {
                if (multiple) index -= 1;
                o[head[index]] = k.innerText;
                if (k.getElementsByClassName('el-switch').length > 0) {
                  if (k.getElementsByClassName('is_checked').length > 0) {
                    o[head[index]] = 'yes';
                  } else {
                    o[head[index]] = 'no';
                  }
                }
                k.getElementsByTagName('img').forEach((item) => {
                  o[head[index]] += item.currentSrc;
                });
              }
            });
            arr1.push(o);
          });
          if (e) arr1 = e;
          // console.log(that.columns,head,key,arr1)
          const { export_json_to_excel } = require('../excel/Export2Excel');
          const tHeader = key; //  head name (pipei)
          const filterVal = head; //  real head name
          const list = arr1;
          const data = that.formatJson(filterVal, list);
          let time1,
            time2 = '';
          if (this.start !== '') {
            time1 = moment(that.start).format('YYYY-MM-DD');
          }
          if (this.end !== '') {
            time2 = moment(that.end).format('YYYY-MM-DD');
          }
          let allList = this.$route.matched.filter((item) => {
            if (item.meta && item.meta.title) {
              return true;
            }
          });
          export_json_to_excel(
            tHeader,
            data,
            `[${time1}]${that.$t(allList[allList.length - 1].meta.title)}`
          ); // excel name
        });
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map((v) => filterVal.map((j) => v[j]));
      },
      allSelect(val) {
        this.selete = val;
      },
      sort_change({ prop, order }) {
        //ascending up id
        if (order === null) {
          this.ordering = '';
          return;
        }
        this.ordering = order === 'ascending' ? prop : `-${prop}`;
      },
      reset(e) {
        Object.keys(this.filter).forEach((key) => {
          if (e.includes(key)) return;
          if (key === 'start_time') {
            this.dateValue = '';
          }
          if (
            key !== 'coupon' &&
            key !== 'club' &&
            key !== 'task' &&
            key !== 'attendance' &&
            key !== 'book' &&
            key !== 'activity' &&
            key !== 'user_id' &&
            key !== 'club_id'
          ) {
            this.filter[key] = '';
          }
          if (key === 'day_of_week') {
            this.day_arr = [];
          }
        });
        this.page = 1;
        this.get_list();
      },
      async get_list() {
        const { pageSize, page } = this;
        const filter = this.filter;
        const data = clean({
          page_size: pageSize,
          page: page,
          ...filter,
          ordering: this.ordering,
        });
        const { results, count } = await axios_get(data);
        this.list_data = {
          list: results,
          total: count,
        };
      },
      async getAllList(type, api) {
        const filter = this.filter;
        const data = clean({
          ...filter,
          ordering: this.ordering,
        });
        if (api) {
          if (type === 'readTask') {
            var special_filter = {
              task__club__id: this.filter.club,
            };
          }
          var { results } = await api(special_filter);
        } else {
          var { results } = await axios_get(data);
        }
        return new Promise((resolve) => {
          resolve(results);
        });
      },
    },
    computed: {
      get_select() {
        return this.selete.map((x) => x.id);
      },
    },
    watch: {
      page() {
        this.get_list();
      },
      pageSize() {
        this.get_list();
      },
      ordering() {
        this.get_list();
      },
    },
    created() {
      this.get_list();
    },
  };
};
